// extracted by mini-css-extract-plugin
module.exports = {"letterRail":"SubSkillRatingModal_letter-rail__39tHB","box":"SubSkillRatingModal_box__1Qc2G"};